import { render, staticRenderFns } from "./updataOldText.vue?vue&type=template&id=f314104a&scoped=true"
import script from "./updataOldText.vue?vue&type=script&lang=js"
export * from "./updataOldText.vue?vue&type=script&lang=js"
import style0 from "./updataOldText.vue?vue&type=style&index=0&id=f314104a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f314104a",
  null
  
)

export default component.exports